import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedBoardId } from '../../../reducers/kanban/boardActions';

/**
 * Componente utilitario para la navegación entre tableros
 * Proporciona una capa de abstracción para la navegación limpia
 */
const BoardRouter = {
  /**
   * Navega a un tablero específico por ID usando navegación limpia
   * @param {string|number} boardId - ID del tablero
   * @param {function} navigate - Función navigate de react-router-dom
   * @param {function} dispatch - Función dispatch de Redux
   * @returns {void}
   */
  navigateToBoard: (boardId, navigate, dispatch) => {
    // Convertir el ID a string y asegurar que sea válido
    const boardIdStr = String(boardId || '').trim();
    
    if (!boardIdStr) {
      console.error('BoardRouter: ID de tablero inválido', boardId);
      return;
    }
    
    // Primero establecer el tablero seleccionado en Redux
    dispatch(setSelectedBoardId(boardIdStr));
    
    // Luego navegar a la URL limpia (sin parámetros)
    navigate('/admin/kanban/board');
  },
  
  /**
   * Hook personalizado para facilitar la navegación limpia a tableros
   * @returns {function} Función para navegar a un tablero por ID
   */
  useNavigateToBoard: () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    return (boardId) => {
      BoardRouter.navigateToBoard(boardId, navigate, dispatch);
    };
  }
};

export default BoardRouter; 